export const VOLUME_UNIT = "gal";
export const KILO_VOLUME_UNIT = "1000 gal";
export const RATIO_UNIT = "gal/ton";
export const GAS_UNIT = "MMBtu";
export const GAS_RATIO_UNIT = "MMBtu/ton";
export const NO_DATA_TEXT = "-";

/** Big totals read cleaner without decimals; small ratios need them. */
const getFractionDigits = (value: number) =>
	Math.abs(value) >= 1000 ? 0 : Math.abs(value) >= 1 ? 1 : 2;

export const formatVolume = (
	value: number | null | undefined,
): string | null =>
	value === null || value === undefined
		? null
		: value.toLocaleString("en-US", {
				maximumFractionDigits: getFractionDigits(value),
			});
export const formatMeasureWithUnit = (
	value: number | null | undefined,
	unit: string,
) => {
	const formatted = formatVolume(value);
	return formatted === null ? "No data" : `${formatted} ${unit}`;
};

export const formatVolumeWithUnit = (value: number | null | undefined) =>
	formatMeasureWithUnit(value, VOLUME_UNIT);

export const formatCurrency = (value: number | null | undefined) => {
	if (value === null || value === undefined) return null;
	return value.toLocaleString("en-US", {
		style: "currency",
		currency: "USD",
		maximumFractionDigits: Math.abs(value) >= 1000 ? 0 : 2,
		minimumFractionDigits: 0,
	});
};
export const formatCostAmount = (value: number | null | undefined) =>
	value === null || value === undefined
		? null
		: value.toLocaleString("en-US", {
				style: "currency",
				currency: "USD",
				maximumFractionDigits: 2,
				minimumFractionDigits: 2,
			});

export const formatCostPerGallonValue = (value: number | null | undefined) =>
	value === null || value === undefined
		? null
		: value.toLocaleString("en-US", {
				style: "currency",
				currency: "USD",
				maximumFractionDigits: 2,
				minimumFractionDigits: 0,
			});

/** Rates come from the API per gallon; the UI prices them per 1000 gallons. */
export const formatCostPerKiloGallonValue = (
	value: number | null | undefined,
) =>
	value === null || value === undefined
		? null
		: formatCostPerGallonValue(value * 1000);
